export const getTheActivityType = (activity) => {
  let type = {}
  if (activity.checkpoint === true && activity.work_product === true) {
    type = {id: 1, name: 'Artifact Required / Check-in', label: 'Artifact Required / Check-in', sort_order: 0}
  } else if (activity.checkpoint === true) {
    type = {id: 2, name: 'Check-in Only', label: 'Check-in Only', sort_order: 1}
  } else if (!activity.checkpoint && !activity.work_product) {
    type = {id: 3, name: 'No Check-in', label: 'No Check-in', sort_order: 2}
  }
  return type
}



// WEBPACK FOOTER //
// ./src/components/mycourses/Activities/getTheActivityTypeFunction.js